/** @constant {string} */
export const GEOBLOCK = 'geoBlock';

/** @constant {string} */
export const US_CONTENT = 'us-content';

/** @constant {string} */
export const REDIRECT_URL = '/?redirected=true';

/** @constant {string} */
export const COUNTRY_HEADER = 'cloudfront-viewer-country';

/** @constant {string} */
export const USER_AGENT_HEADER = 'user-agent';

/** @constant {string} */
export const US = 'US';

/**
 * Check to see if user agent is a bot
 * @param {import('next').GetServerSidePropsContext} context
 * @returns {boolean}
 */
export const isBotDetected = (context) => {
	const keys = Object.keys(context.req.headers);
	// Case insensitive check for request header
	const foundKey = keys.find((key) => key.toLowerCase() === USER_AGENT_HEADER);
	// Regex to check for common bots and crawlers
	const BOT_REGEX = /bot|crawl|crawler|spider|crawling|facebook|twitter|slack/i;

	// Check if the user agent is a bot
	return (
		typeof foundKey === 'string' ? BOT_REGEX.test(context.req.headers[foundKey]) : false
	);
};

/**
 * Returns true if request is geographically from the US
 * Intended to be used inside the getServerSideProps function.
 * @param {import('next').GetServerSidePropsContext} context
 * @returns {boolean}
 */
export const isUsTraffic = (context) => {
	const keys = Object.keys(context.req.headers);
	// Check if traffic is coming from a user agent marked as a bot
	const isBot = isBotDetected(context);
	// Case insensitive check for request header
	const foundKey = keys.find((key) => key.toLowerCase() === COUNTRY_HEADER);
	// ISO 3166 Country codes are case-insensitive
	return (
		typeof foundKey === 'string' ? context.req.headers[foundKey].toUpperCase() === US && !isBot : false
	);
};

/**
 * Returns true if given item is US content and the request of from the US
 * Intended to be used inside the getServerSideProps function.
 * @param {Object} wpObject
 * @param {Object} context
 * @returns {boolean}
 */
export const isGeoBlocked = (wpObject, context) => {
	let isUsContent = false;

	if (wpObject.distributions.nodes) {
		// Article or recipe
		const postIsUsContent = wpObject.distributions.nodes.some((item) => item.slug === US_CONTENT);
		const featuredTagIsUsContent = wpObject.featuredTag?.recipeDetailFeaturedTag?.distributions.some((item) => item === US_CONTENT);
		isUsContent = postIsUsContent || featuredTagIsUsContent;
	} else {
		// Tag
		isUsContent = wpObject.distributions.some((item) => item === US_CONTENT);
	}

	return isUsContent && isUsTraffic(context);
};
